import { render, staticRenderFns } from "./associativeClassification.vue?vue&type=template&id=2f239346&scoped=true"
import script from "./associativeClassification.vue?vue&type=script&lang=js"
export * from "./associativeClassification.vue?vue&type=script&lang=js"
import style0 from "./associativeClassification.vue?vue&type=style&index=0&id=2f239346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f239346",
  null
  
)

export default component.exports